import HeaderCellBoldWithInfoIcon from "app/components/React/Table/headerCells/HeaderCellBoldWithInfoIcon";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { translate } from "app/filters/i18nFilter";

import IntentScoreDeltaCell from "../../../components/shared/IntentScoreDeltaCell/IntentScoreDeltaCell";
import { StyledScoreValue, StyledScoreWrapper, StyledTextCell } from "../../../components/tooltips/shared/styles";
import type IntentSignalRowDto from "../../../models/intent/IntentSignalRowDto";
import isIntentSignalDomainsRowDto from "../../../models/intent/type-guards/isIntentSignalDomainsRowDto";
import type TooltipTableColumn from "../../../models/view/signals-tooltip/TooltipTableColumn";
import createSignalsTooltipTableColumn from "../base/toolipBaseColumnFactory";

import {
    TOOLTIP_COLUMN_DOMAINS_NAME,
    TOOLTIP_COLUMN_SCORE_DELTA_NAME,
    TOOLTIP_COLUMN_SCORE_NAME,
    TOOLTIP_COLUMN_TOPIC_NAME,
} from "./const";

const COLUMN_DISPLAY_NAME_KEY = "si.signals.table-columns.tooltip.table.column";

type Deps = {
    tableRowData: IntentSignalRowDto[];
};

export default function createTooltipColumnsResolver({ tableRowData }: Deps) {
    const shouldDisplayDomainsColumn = isIntentSignalDomainsRowDto(tableRowData[0]);

    const createScoreOrDomainsColumn = (): TooltipTableColumn => {
        if (shouldDisplayDomainsColumn) {
            return createSignalsTooltipTableColumn({
                field: TOOLTIP_COLUMN_DOMAINS_NAME,
                displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.domains-number`),
                maxWidth: 95,
                cellComponent: ({ value: numberOfDomains }: ITableCellProps<IntentSignalRowDto[]>) => {
                    return (
                        <StyledTextCell data-automation-cell-value={numberOfDomains}>
                            {translate(`${COLUMN_DISPLAY_NAME_KEY}.domains-number.text`, { numberOfDomains })}
                        </StyledTextCell>
                    );
                },
            });
        }

        return createSignalsTooltipTableColumn({
            field: TOOLTIP_COLUMN_SCORE_NAME,
            displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.score-name`),
            headerComponent: (props) => (
                // @ts-expect-error FIXME: Property 'displayName' is missing in type '{ tooltipText: string; }' but required in type 'HeaderCellBoldWithInfoIconProps'
                <HeaderCellBoldWithInfoIcon
                    {...props}
                    tooltipText={`${COLUMN_DISPLAY_NAME_KEY}.score-name.tooltip`}
                />
            ),
            maxWidth: 60,
            cellComponent: (props: ITableCellProps) => {
                return (
                    <StyledScoreWrapper>
                        <StyledScoreValue>{props.value}</StyledScoreValue>
                        <IntentScoreDeltaCell
                            {...props.row}
                            value={props.row[TOOLTIP_COLUMN_SCORE_DELTA_NAME]}
                        />
                    </StyledScoreWrapper>
                );
            },
        });
    };

    return {
        getTableColumns(): TooltipTableColumn[] {
            return [
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_TOPIC_NAME,
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.topic-name`),
                    maxWidth: 237,
                    cellComponent: ({ value }: ITableCellProps<string>) => {
                        return <StyledTextCell data-automation-cell-value={value}>{value}</StyledTextCell>;
                    },
                }),
                createScoreOrDomainsColumn(),
            ];
        },
    };
}
